/**
 * Utility to handle viewport height calculations correctly on mobile devices
 * 
 * This solves the issue with 100vh calculations on mobile browsers where
 * the viewport height changes when the address bar appears/disappears.
 */

// Store the real viewport height
let realViewportHeight = window.innerHeight;

// CSS variable name to store viewport height
const CSS_VAR_NAME = '--real-viewport-height';

/**
 * Update the CSS variable with the real viewport height
 */
function updateViewportHeight() {
  realViewportHeight = window.innerHeight;
  document.documentElement.style.setProperty(CSS_VAR_NAME, `${realViewportHeight}px`);
  
  // Also set percentage-based variables for convenience
  document.documentElement.style.setProperty('--vh-100', `${realViewportHeight}px`);
  document.documentElement.style.setProperty('--vh-90', `${realViewportHeight * 0.9}px`);
  document.documentElement.style.setProperty('--vh-80', `${realViewportHeight * 0.8}px`);
  document.documentElement.style.setProperty('--vh-70', `${realViewportHeight * 0.7}px`);
  document.documentElement.style.setProperty('--vh-50', `${realViewportHeight * 0.5}px`);
}

/**
 * Initialize the viewport height tracking
 */
export function initViewportHeightFix() {
  // Initial update
  updateViewportHeight();
  
  // Listen for resize and orientation change events
  window.addEventListener('resize', updateViewportHeight);
  window.addEventListener('orientationchange', updateViewportHeight);
  
  // Some mobile browsers require a small delay after orientation change
  window.addEventListener('orientationchange', () => {
    setTimeout(updateViewportHeight, 100);
  });
  
  // Return a cleanup function
  return () => {
    window.removeEventListener('resize', updateViewportHeight);
    window.removeEventListener('orientationchange', updateViewportHeight);
  };
}

/**
 * Get the current real viewport height
 */
export function getRealViewportHeight() {
  return realViewportHeight;
}
